module.exports = __webpack_public_path__ + "img/outcome_wrong_answer.f14280f7.svg";